<template>
  <LayoutDashboard title="Produtos">
    <v-card outlined>
      <v-card-title class="">
        <!-- <v-flex xs12 md6> -->
        <v-btn
          color="primary"
          class="ma-1"
          @click="cadastrarProduto"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-produto')"
          >Cadastrar</v-btn
        >
        <v-btn
          color="warning"
          class="ma-1"
          @click="$router.push({ name: 'transferenciasEstoques' })"
          outlined
          v-if="$helper.verificaPermissao('visualizar-transferencia-estoque')"
          >Transferências</v-btn
        >
        <v-btn
          color="default"
          class="ma-1"
          @click="setModalImprimirEstoque(true)"
          v-if="$helper.verificaPermissao('imprimir-estoque')"
          outlined
          >Imprimir Estoque</v-btn
        >
        <v-checkbox
          v-model="dataPagina.desabilitado"
          :label="`Desabilitados`"
          @change="debouncedPesquisar()"
        ></v-checkbox>
        <!-- </v-flex> -->
        <!-- <v-flex xs12 md4>
            <span class="float-right title mr-10 ml-1">
              <h5>
                Página: {{ getProdutos.current_page }} de
                {{ getProdutos.last_page }}
              </h5>
            </span>
            <span class="float-right title mr-1 ml-1">
              <h5>-</h5>
            </span>
          </v-flex>
          <v-flex xs12 md2> -->
        <v-spacer></v-spacer>
        Produtos: {{ getProdutos.total }} -
        <v-pagination
          outlined
          total-visible="7"
          v-model="getProdutos.current_page"
          :length="getProdutos.last_page"
          @input="visualizarPagina($event)"
        ></v-pagination>
        <!-- <v-icon class=" mr-1 ml-1" v-if="getProdutos.current_page > 1" @click="visualizarPagina(1)"> mdi-arrow-collapse-left</v-icon>
            <v-icon class=" mr-1 ml-1" v-if="getProdutos.current_page > 1" @click="visualizarPagina(getProdutos.current_page - 1)">keyboard_arrow_left</v-icon>
            <v-icon class="mr-1 ml-1" v-if="getProdutos.current_page < getProdutos.last_page" @click="visualizarPagina(getProdutos.current_page + 1)">keyboard_arrow_right</v-icon>
            <v-icon class="mr-1 ml-1" v-if="getProdutos.current_page < getProdutos.last_page" @click="visualizarPagina(getProdutos.last_page)">mdi-arrow-collapse-right</v-icon>
          </v-flex> -->
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <td width="9%">
                  <v-text-field
                    v-model="dataPagina.id"
                    label="Código"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="dataPagina.descricao"
                    label="Descrição"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    id="descricao"
                  ></v-text-field>
                </td>
                <td></td>
                <td>
                  <!-- <v-autocomplete label="marca" :items="getMarcas" v-model="dataPagina.marca" item-text="marca"
                    item-value="marca" outlined dense class="mt-2" @input="debouncedPesquisar()"></v-autocomplete> -->
                  <v-text-field
                    label="Marca"
                    class="mt-2"
                    v-model="dataPagina.marca"
                    outlined
                    dense
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </td>
                <!-- <td>
                  <v-autocomplete v-model="dataPagina.secao_id" :items="getSecoesProduto" label="Departamento"
                    item-text="secao" item-value="id" outlined dense class="mt-2" @input="debouncedPesquisar()">
                  </v-autocomplete>
                </td> -->

                <td>
                  <v-autocomplete
                    v-model="dataPagina.grupo_id"
                    :items="['', ...getGruposProduto]"
                    label="Grupo"
                    item-text="grupo"
                    item-value="id"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  >
                  </v-autocomplete>
                </td>
                <td>
                  <v-autocomplete
                    v-model="dataPagina.estoque_id"
                    :items="getEstoques"
                    label="Estoque"
                    item-text="nome"
                    item-value="id"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-autocomplete>
                </td>
                <td width="7%">
                  <v-select
                    outlined
                    dense
                    :items="resultadosPorPagina"
                    item-value="value"
                    item-text="label"
                    v-model="limitePorPagina"
                    label="Exibir"
                    @change="visualizarPagina(getProdutos.current_page)"
                    class="mt-2"
                  ></v-select>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in getProdutos.data" :key="p.id">
                <td align="center" width="8%">{{ p.id }}</td>
                <td width="35%">{{ p.descricao }}</td>
                <td>{{ $helper.formatReal(parseFloat(p.preco_venda)) }}</td>
                <td>{{ p.marca }}</td>
                <!-- <td>{{p.secao ? p.secao.secao : ''}}</td> -->
                <td>{{ p.grupo ? p.grupo.grupo : "" }}</td>
                <td
                  width="10%"
                  v-if="p.estoque[0]"
                  align="center"
                  :class="getCorSituacaoEstoque(p)"
                >
                  {{ p.estoque[0].quantidade }}
                </td>
                <td align="center" v-else class="estoqueNegativo">
                  0
                </td>
                <td align="center" width="10%">
                  <TooltipButton
                    @click.native="visualizarProduto(p.id)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-produto')"
                  />

                  <v-menu
                    bottom
                    left
                    transition="slide-y-transition"
                    class="ml-10 mr-10"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="vender(p)">
                        <v-list-item-action>
                          <v-icon>attach_money</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Vender</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        @click="
                          cadastrarTransferenciaEstoque(true),
                            setProduto({ ...p, quantidade: 1 })
                        "
                        v-if="
                          $helper.verificaPermissao(
                            'cadastrar-transferencia-estoque'
                          )
                        "
                      >
                        <v-list-item-action>
                          <v-icon>import_export</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            >Transferir Estoque</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        @click="setModalExcluirProduto(true), setProduto(p)"
                        v-if="$helper.verificaPermissao('excluir-produto')"
                      >
                        <v-list-item-action>
                          <v-icon>clear</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            >Trocar Mercadoria</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <h3>Produtos: {{ getProdutos.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getProdutos.current_page"
          :length="getProdutos.last_page"
          @input="visualizarPagina($event)"
        ></v-pagination>
      </v-card-actions>
    </v-card>
    <ModalCadastro v-if="getModalCadastroProduto" />
    <ModalExcluir />
    <ModalTransferenciaEstoque />
    <ModalImprimirEstoque v-if="getModalImprimirEstoque" />
  </LayoutDashboard>
</template>

<script>
import Produto from "@/services/ProdutoService";
import ModalCadastro from "@/pages/produto/ModalCadastro";
import { mapGetters, mapActions } from "vuex";
import ModalExcluir from "@/pages/produto/ModalExcluir";
import ModalTransferenciaEstoque from "@/pages/estoque/transferencia/ModalCadastro";
import ModalImprimirEstoque from "@/pages/estoque/ModalImprimir";

var _ = require("lodash");

export default {
  components: {
    ModalCadastro,
    ModalExcluir,
    ModalTransferenciaEstoque,
    ModalImprimirEstoque,
  },
  data() {
    return {
      valorPesquisa: "",

      limitePorPagina: 20,
      dataPagina: {
        pagina: 1,
        query: {
          campo: "descricao",
          valor: "",
        },
        id: "",
        descricao: "",
        codigo_barra: "",
        marca: "",
        secao_id: "",
        grupo_id: "",
        estoque_id: 1,
        desabilitado: false,
      },
      resultadosPorPagina: [
        {
          label: "10",
          value: 10,
        },
        {
          label: "20",
          value: 20,
        },
        {
          label: "30",
          value: 30,
        },
        {
          label: "40",
          value: 40,
        },
        {
          label: "50",
          value: 50,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getProdutos",
      "getSecoesProduto",
      "getGruposProduto",
      "getEstoques",
      "getMarcas",
      "getModalCadastroProduto",
      "getModalCadastroTransferenciaEstoque",
      "getModalImprimirEstoque",
    ]),
  },
  watch: {
    valorPesquisa() {
      this.debouncedPesquisar();
    },
    getModalCadastroProduto() {
      if (this.getModalCadastroProduto == false) {
        this.dataPagina.id = "";
        this.dataPagina.descricao = "";
        this.dataPagina.codigo_barra = "";
        this.dataPagina.marca = "";
        this.dataPagina.secao_id = "";
        this.dataPagina.grupo_id = "";
        this.dataPagina.estoque_id = 1;
        setTimeout(() => {
          document.getElementById("descricao").focus();
        }, 10);
      }
    },
  },
  methods: {
    ...mapActions([
      "listarProdutos",
      "visualizarProduto",
      "cadastrarProduto",
      "setModalCadastroProduto",
      "produtoVisualizarPagina",
      "setModalExcluirProduto",
      "setProduto",
      "cadastrarTransferenciaEstoque",
      "setModalImprimirEstoque",
      "listarSecoesProduto",
      "listarGruposProduto",
      "listarEstoque",
      "listarMarcas",
      "getModalImprimirEstoque",
    ]),
    visualizarPagina(pagina) {
      this.dataPagina.pagina = pagina;
      this.dataPagina.path = this.getProdutos.path;
      this.dataPagina.limite = this.limitePorPagina;
      this.listarProdutos(this.dataPagina);
    },
    pesquisarProduto() {
      this.dataPagina.path = this.getProdutos.path;
      this.dataPagina.limite = this.limitePorPagina;
      this.listarProdutos(this.dataPagina);
    },
    getEstoquePrincipal(item) {
      if (estoque[0]) {
        return estoque[0].quantidade;
      } else {
        return "0.00";
      }
    },
    getCorSituacaoEstoque(item) {
      if (item.estoque[0] && item.estoque[0].quantidade <= 0) {
        return "estoqueNegativo";
      } else if (
        item.estoque[0] &&
        item.estoque[0].quantidade <= item.estoque_minimo &&
        item.estoque[0].quantidade > 0
      ) {
        return "estoqueBaixo";
      } else if (!item.estoque[0]) {
        return "estoqueNegativo";
      } else {
        return "estoquePositivo";
      }
    },
    vender(item) {
      let produto = item;
      produto.preco_venda = this.$helper.formatReal(
        parseFloat(item.preco_venda)
      );
      this.$store.commit("setProdutoVenda", produto);
      this.$router.push({ name: "vendaConverter" });
    },
    pesquisar() {
      this.dataPagina.pagina = 1;
      this.dataPagina.path = this.getProdutos.path;
      this.dataPagina.limite = this.limitePorPagina;
      this.listarProdutos(this.dataPagina);
    },
  },
  created() {
    this.dataPagina.limite = this.limitePorPagina;
    this.listarProdutos(this.dataPagina);
    // this.listarSecoesProduto();
    this.listarGruposProduto();
    this.listarEstoque();
    // this.listarMarcas()
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>
<style scoped>
.estoqueNegativo {
  background-color: #ff9795;
}
.estoqueBaixo {
  background-color: #ffd38b;
}
.estoquePositivo {
  background-color: #82d5ff;
}
</style>
